module.exports = __webpack_public_path__ + "img/list.17b8b0cf.svg";